import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { compare } from 'fast-json-patch';
import {AppSettingsService} from '../../../services/appsettings.service';
import {OBViewModel} from '../../../models/OBViewModel';
import { Observable } from 'rxjs';
import {AppSettings} from '../../../app.settings';


@Component({
  selector: 'app-wizardpage-step18-review',
  templateUrl: './wizardpage-step18.component.html',
  styleUrls: ['./wizardpage-step18.component.scss']
})
export class WizardpageStep18ReviewComponent implements OnInit {


  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  onBaseURL: string;
  private settings: AppSettings;
  initForm: any;
  isfetching: boolean;
  obviewmodel: OBViewModel[];

  testnow: any[];


  @Input() regForm: UntypedFormGroup;
  @Input() conForm: UntypedFormGroup;


  constructor(private dialog: MatDialog, private appSettingsService: AppSettingsService) {

    const observable = new Observable();
   // this.showProgressSpinnerUntilExecuted(observable);


    this.appSettingsService.getSettings().subscribe(settings => this.settings = settings,
    () => null,
    () => {
      this.onBaseURL = this.settings.onBaseServer;
    });

   }





  ngOnInit(): void {

    this.initForm = this.regForm.value;
    this.isfetching = false;
  }



  decreasePage() {
    this.pagecountevnt.emit(0);
  }




  step18Submitted(postValue: UntypedFormGroup) {

    const documentA = this.initForm;
    const documentB = postValue.value;

    this.isfetching = true;


    const jsonpatchobject = compare(documentA, documentB);

    this.continueevnt.emit(postValue.value);


   }


   sendOBrecordToPost(e) {
    this.obviewmodel = e;
}




   isFetching(e) {
    this.isfetching = e; }

}
